<template>
    <header class="header-global">
        <div class="dblclick" @dblclick="onDoubleClick"></div>
        <div class="dblclick_input">
            <base-input v-if="showInput" v-model="password" alternative placeholder="请输入彩蛋密码"
                @keyup.enter="submitPassword">
            </base-input>
        </div>
        <base-nav :class="{ 'shadow': scrollY }" :style="navbarStyle" transparent type=""
            :effect="isScrolled ? 'dark' : 'light'" expand>
            <router-link slot="brand" class="navbar-brand" to="/">
                <img src="img/pay/0--06.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="#/">
                        <img src="img/pay/0--06.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <li class="nav-item">
                    <router-link to="/" class="nav-link btn-link text-default">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">{{ $t('nav.home') }}</span>
                    </router-link>
                </li>
                <!-- <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#/product" class="nav-link" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">{{ $t('nav.product') }}</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <div class="media d-flex align-items-center" v-for="(item, index) in source" :key="index">
                            <div class="icon icon-shape">
                                <img :src="item.icon" alt="">
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">
                                    <router-link class="d_c btn-link text-default" :to="item.href">
                                        {{ item.title }}<i class="ni ni-bold-right"></i>
                                    </router-link>
                                </h6>
                                <hr style="margin: 4px 0 5px;" />
                                <p class="d-md-inline-block mb-0">
                                    <router-link class="text-default w140 c_t" :to="item.children[0].href">{{
                                        item.children[0].title
                                        }} &gt;</router-link>
                                    <router-link class="text-default c_t ml-4" :to="item.children[1].href">{{
                                        item.children[1].title }}
                                        &gt;</router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                </base-dropdown> -->
                <!-- <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#/number" class="nav-link" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">{{ $t('network.title') }}</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <div class="media d-flex align-items-center" v-for="(item, index) in source1" :key="index">
                            <div class="icon icon-shape">
                                <img :src="item.icon" alt="">
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">
                                    <router-link class="d_c btn-link text-default" :to="item.href">
                                        {{ item.title }}<i class="ni ni-bold-right"></i>
                                    </router-link>
                                </h6>
                                <hr style="margin: 8px 0 0;" />
                            </div>
                        </div>
                    </div>
                </base-dropdown> -->
                <li class="nav-item">
                    <router-link to="/product/0" class="nav-link btn-link text-default">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">{{ $t('nav.product') }}</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/number/0" class="nav-link btn-link text-default">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">{{ $t('nav.life') }}</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/about/0" class="nav-link btn-link text-default">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">{{ $t('nav.about') }}</span>
                    </router-link>
                </li>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <base-dropdown>
                    <base-button slot="title" size="sm" outline type="default" class="dropdown-toggle">
                        <img :src="currentFlag" /> 
                    </base-button>
                    <li>
                        <a class="dropdown-item" @click="changeLang('zh')">
                            <img src="/img/flags/CN.png" /> 中文
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" @click="changeLang('en')">
                            <img src="/img/flags/US.png" /> English
                        </a>
                    </li>
                </base-dropdown>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="#/help">
                        <span class="nav-link-inner--text">{{ $t('nav.help') }}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="download nav-link nav-link-icon" href="#/download">
                        <span class="nav-link-inner--text">{{ $t('nav.download') }}</span>
                        <img class="download_img d-ls-none" src="/img/pay/0-_icon-02.png" alt="">
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>

<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
    components: {
        BaseNav,
        BaseDropdown,
        CloseButton
    },
    data() {
        // 从本地存储获取语言设置，如果没有则使用默认值
        const savedLang = localStorage.getItem('lang') || 'zh';
        return {
            currentLang: savedLang === 'en' ? 'English' : '中文',
            currentFlag: savedLang === 'en' ? '/img/flags/US.png' : '/img/flags/CN.png',
            isScrolled: false,
            opacity: 0,
            scrollY: 0,
            showInput: false, // 控制输入框的显示
            password: '', // 用于存储输入的密码
            // pwi: window.innerWidth,
            // source: 
        }
    },
    computed: {
        source() {
            return [
                {
                    title: this.$t('network.title'),
                    href: '/network',
                    icon: '/img/pay/0-_icon-1.png',
                    children: [
                        {
                            title: this.$t('cost.title'),
                            href: '/cost'
                        },
                        {
                            title: this.$t('bill.title'),
                            href: '/bill'
                        }
                    ]
                },
                {
                    title: this.$t('currency.title'),
                    href: '/currency',
                    icon: '/img/pay/0--11.png',
                    children: [
                        {
                            title: this.$t('settlement.title'),
                            href: '/settlement'
                        },
                        {
                            title: this.$t('exchange.title'),
                            href: '/exchange'
                        }
                    ]
                },
                {
                    title: this.$t('plan.title'),
                    href: '/plan',
                    icon: '/img/pay/0-_icon-2.png',
                    children: [
                        {
                            title: this.$t('enterprise.title'),
                            href: '/enterprise'
                        },
                        {
                            title: this.$t('account.title'),
                            href: '/account'
                        }
                    ]
                },
                {
                    title: this.$t('security.title'),
                    href: '/security',
                    icon: '/img/pay/0-_icon-3.png',
                    children: [
                        {
                            title: this.$t('organization.title'),
                            href: '/organization'
                        },
                        {
                            title: this.$t('fund.title'),
                            href: '/fund'
                        }
                    ]
                },
            ];
        },
        source1() {
            return [
                {
                    title: this.$t('travel.title'),
                    href: '/travel',
                    icon: '/img/pay/0-_icon-4.png',
                },
                {
                    title: this.$t('life.title'),
                    href: '/life',
                    icon: '/img/pay/0-_icon-6.png',
                },
                {
                    title: this.$t('entertainment.title'),
                    href: '/entertainment',
                    icon: '/img/pay/0--16.png',
                },
                {
                    title: this.$t('journey.title'),
                    href: '/journey',
                    icon: '/img/pay/0-_icon-7.png',
                },
            ]
        },
        source2() {
            return [
                {
                    title: this.$t('about.title'),
                    href: '/about',
                    icon: '/img/pay/0-_icon-8.png',
                    description: this.$t('about.blurb'),
                },
                {
                    title: this.$t('cooperation.title'),
                    href: '/cooperation',
                    icon: '/img/pay/0-_icon-9.png',
                    description: this.$t('cooperation.blurb'),
                },
                {
                    title: this.$t('license.title'),
                    href: '/license',
                    icon: '/img/pay/0-_icon-11.png',
                    description: this.$t('license.blurb'),
                },
            ]
        },
        navbarStyle() {
            return {
                backgroundColor: `rgba(255, 255, 255, ${this.opacity})`,
                // 确保文本颜色在透明度变化时仍然清晰
                color: this.isScrolled ? '#000' : '#fff',
                height: '68px',
            };
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            // 计算透明度：滚动高度越大，透明度越高
            const scrollY = window.scrollY;
            this.scrollY = scrollY;
            // 设置最大滚动高度为500px，此时透明度为0.95
            const maxScroll = 200;
            // 计算透明度值 (0完全透明到0.95几乎不透明)
            this.opacity = Math.min(scrollY / maxScroll, 1);
            // 同时保持isScrolled状态用于控制文本颜色
            this.isScrolled = scrollY > 100;
        },
        changeLang(lang) {
            // 保存当前路由到本地存储
            // localStorage.setItem('lastRoute', this.$route.fullPath);

            this.$i18n.locale = lang;
            // 保存语言设置到本地存储
            localStorage.setItem('lang', lang);
            if (lang === 'en') {
                this.currentLang = 'English';
                this.currentFlag = '/img/flags/US.png';
            } else {
                this.currentLang = '中文';
                this.currentFlag = '/img/flags/CN.png';
            }

            // 刷新页面
            // window.location.reload();
        },
        onDoubleClick() {
            // 双击事件处理逻辑
            this.showInput = !this.showInput; // 切换输入框的显示状态
            console.log('Header double-clicked');
        },
        submitPassword() {
            if (this.password === '') return this.showInput = false;
            // 简单加密：将正确密码用 base64 编码
            const encode = str => btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => String.fromCharCode('0x' + p1)));
            const correct = "6Z2e5rSy5LmL5b+D";
            console.log('Encoded password:', encode(this.password));
            // 提交密码逻辑
            if (encode(this.password) === correct) {
                // 跳转到彩蛋页面
                this.$router.push('/egg/' + encode(this.password));
                this.showInput = false; // 隐藏输入框  
                this.password = ''; // 清空密码输入
            } else {
                this.password = ''; // 清空密码输入
                alert('密码错误，请在项目中寻找！');
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.header-global {
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100%;
    // background-color: white;
}

.download {
    display: flex;
    align-items: center;

    .download_img {
        width: 18px;
        height: 18px;
        margin-left: 5px;
    }
}

.d_c {
    display: flex;
    align-items: center;
}

.w140 {
    min-width: 140px;
    display: inline-block;
}

.c_t {
    color: black !important;
    font-size: 14px;
    display: inline-block;
}

.dblclick {
    position: absolute;
    left: 0;
    height: 68px;
    width: 10px;
    z-index: 999;
    background-color: transparent;
    // border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: rgba($color: #eee, $alpha: .7); // 鼠标悬停时变色
    }
}

.dblclick_input {
    position: absolute;
    left: 20px;
    z-index: 999;
    height: 68px;
    display: flex;
    align-items: center;

    .form-group {
        margin: 0;
    }
}
</style>
